import Http from "../common/utils/Http";

export const contactList = async () => {
    try {
        return await Http.get('home/content/contact');
    } catch (error) {
        throw error;
    }
}
